__turbopack_context__.v({
  "backToTop": "LandingPageFooter-module__uCmpaq__backToTop",
  "bottomSection": "LandingPageFooter-module__uCmpaq__bottomSection",
  "circle": "LandingPageFooter-module__uCmpaq__circle",
  "container": "LandingPageFooter-module__uCmpaq__container",
  "copyright": "LandingPageFooter-module__uCmpaq__copyright",
  "emailInput": "LandingPageFooter-module__uCmpaq__emailInput",
  "footer": "LandingPageFooter-module__uCmpaq__footer",
  "headline": "LandingPageFooter-module__uCmpaq__headline",
  "headlineSection": "LandingPageFooter-module__uCmpaq__headlineSection",
  "inputWrapper": "LandingPageFooter-module__uCmpaq__inputWrapper",
  "legalLink": "LandingPageFooter-module__uCmpaq__legalLink",
  "legalLinks": "LandingPageFooter-module__uCmpaq__legalLinks",
  "link": "LandingPageFooter-module__uCmpaq__link",
  "linkColumn": "LandingPageFooter-module__uCmpaq__linkColumn",
  "linkHovered": "LandingPageFooter-module__uCmpaq__linkHovered",
  "linksSection": "LandingPageFooter-module__uCmpaq__linksSection",
  "logo": "LandingPageFooter-module__uCmpaq__logo",
  "logoWrapper": "LandingPageFooter-module__uCmpaq__logoWrapper",
  "newsletter": "LandingPageFooter-module__uCmpaq__newsletter",
  "newsletterText": "LandingPageFooter-module__uCmpaq__newsletterText",
  "submitButton": "LandingPageFooter-module__uCmpaq__submitButton",
  "topSection": "LandingPageFooter-module__uCmpaq__topSection",
});
